export const getRegionEntries = (regionsDictionary) =>
  Object.entries(regionsDictionary).filter(
    ([key]) =>
      ![
        "sectionTitle",
        "sectionSubtitle",
        "all",
        "mapTitle",
        "chipsTitle",
        "loadingMap",
      ].includes(key),
  );

export const normalizeTextSearch = (value = "") => value.toLowerCase().trim();
